export default __webpack_public_path__ + "static/media/UW-logo@2x.7ce3df2a.png";